import Link from "next/link";

type SafetyDisclaimerProps = {
  tone?: "light" | "dark";
};

export function SafetyDisclaimer({ tone = "light" }: SafetyDisclaimerProps) {
  const dark = tone === "dark";
  return (
    <p
      className={[
        "rounded-md border px-4 py-3 text-[12.5px] leading-relaxed",
        dark
          ? "border-white/14 bg-white/[0.07] text-white/68"
          : "border-border-light bg-white text-text-muted",
      ].join(" ")}
    >
      PeakWave scores are planning signals, not safety clearance. Check local
      authorities, official bulletins and on-site conditions before you go.{" "}
      <Link
        href="/editorial-policy"
        className={dark ? "font-semibold text-gold-light no-underline hover:underline" : "font-semibold text-gold no-underline hover:underline"}
      >
        Read our editorial policy
      </Link>
      .
    </p>
  );
}
